import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { DimensionValueSet } from "@/lib/dimensions";
import { LegendItem } from "@/features/shared/widgets/map/map.styles";
import { legendImageQueryOptions } from "@/features/shared/widgets/map/legends/legend-image-query";

interface LegendImageProps {
  layerId: string;
  opacity?: number;
  loadLegendImage: (dimensionValues: DimensionValueSet) => Promise<Blob | undefined>;
  dimensionValues: DimensionValueSet;
}

const LegendImage = ({
  layerId,
  opacity,
  loadLegendImage,
  dimensionValues,
}: LegendImageProps) => {
  const legendQuery = useQuery({
    ...legendImageQueryOptions(layerId, dimensionValues, loadLegendImage),
    placeholderData: keepPreviousData,
    retry: false,
  });

  if (legendQuery.isLoading) return <span>Loading legend...</span>;
  if (legendQuery.isError) return <span>Failed to load legend</span>;
  if (!legendQuery.data) return null;

  return (
    <LegendItem>
      <img src={legendQuery.data} style={{ opacity: opacity ?? 1.0 }} />
    </LegendItem>
  );
};

export default LegendImage;
